import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { RestClientService } from '../../../../core/service/rest-client.service';
import { AuthService } from '../../../../core/service/auth.service';
import { UtilitiesService } from '../../../../core/service/utilities.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { ScrollSearchMedocPrestaComponent } from '@shared/components/scroll-search-medoc-presta/scroll-search-medoc-presta.component';
import { PrestationInfoComponent } from '@shared/components/prestation-info/prestation-info.component';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { SearchExamenLaboComponent } from '@shared/components/search-examen-labo/search-examen-labo.component';
import { SearchFormComponent } from "@shared/components/search-form/search-form.component";
import { SearchExamenRadioComponent } from "@shared/components/search-examen-radio/search-examen-radio.component";

@Component({
  selector: 'app-form-pres-radio',
  standalone: true,
  imports: [CommonModule, NgSelectModule, FormsModule, BenefInfoComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    FileUploadComponent,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule,
    ScrollSearchMedocPrestaComponent,
    BenefInfoComponent,
    PrestationInfoComponent,
    SearchMdicamentProComponent,
    SearchExamenLaboComponent, SearchFormComponent, SearchExamenRadioComponent],
  templateUrl: './form-pres-radio.component.html',
  styleUrl: './form-pres-radio.component.css'
})
export class FormPresRadioComponent {
  selectedTab = 'tab1';
    @Output() onSendBenefItem = new EventEmitter<any>();
    @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
    @Output() onGoToTab = new EventEmitter<any>();
    @Input() matricule: any
    cancelItemSelected = false
    @Input() refreshTriggerOrdonnance!: boolean;
  
    current_medicament_id: any = ''
    reload = false
    produit: string = '';
    clearText = false
    posologie: string = '';
    frequence: string = '';
    renouvellement: string = '';
    quantite: number = 1;
    items: any = []
    selectedItem: any = {}
    dossierActif: any = {}
    prestationActive: any = {}
    itemsElement: any = []
  
  
    isLoading: boolean | undefined;
    input_value: any;
    input_option = 'MAT';
    searchPlaceHolder = 'Entrez numéro matricule'
  
    user: any = {};
    isConsultationSuccess = false;
    itemConsultation: any = {};
    itemToAdd: any = {}
    itemToSave: any = {}
    itemsModePrescription = [{ code: 'produit', libelle: 'Produit' }, { code: 'molecule', libelle: 'Molécule' }]
    // model: NgbDateStruct | undefined;
    itemBeneficiare: any = {};
    fileName1: any;
    currentFile: any;
    selectedConsultation:any=[]
    itemsAffection: any;
    itemsPrescription: any;
    selectedPrescription: any;
  beneficiaireAutOselect: any;
    itemsGarantie: any;
    constructor(
      private restClient: RestClientService,
      private router: Router,
      private authService: AuthService,
      private utilities: UtilitiesService
    ) {
      this.user = this.authService.getCurrentUser();
      console.log('connected user: ', this.user);
      this.itemToAdd = {}
      this.itemToSave.mode_prescription = 'produit'
      // this.getItemsAffection()
      this.itemToSave.date_prescription = {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1, // getMonth() returns 0-11
        day: new Date().getDate()
      };
      // let activeBeneficiaire = this.authService.getActiveBeneficiaire()
      // if (activeBeneficiaire.matricule) {
      //   this.searcheBenef(activeBeneficiaire.matricule)
      // }
      this.beneficiaireAutOselect= this.authService.getActiveBeneficiaire()
      this.getItemsGarantie()
  
  
    }
  
    getItemsAffection() {
      let request = {
        index: 0,
        size: 1000,
        data: {},
      };
  
      this.restClient.post('affection/getByCriteria', request).subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res && !res['hasError'] && res['items']) {
            this.itemsAffection = res.items;
            console.log('this.itemsAffection: ', this.itemsAffection);
          } else {
            this.utilities.showSweetNotification(
              res['status']['message'],
              'error'
            );
            this.itemsAffection = [];
          }
        },
        (error) => {
          this.utilities.showSweetNotification(error, 'error');
          this.itemsAffection = [];
        }
      );
    }
  
  
    onSelectTab(tab: string) {
      this.selectedTab = tab;
    }
  
    onChangeInputMode() {
      this.input_value = '';
      this.searchPlaceHolder = this.input_option == 'MAT' ? 'Entrez numéro matricule' : 'Entrez numéro cnam'
    }
  
    searcheBenef(activeBenefMatricule?: any) {
      this.itemsPrescription = []
      if (!this.input_value && activeBenefMatricule) {
        this.input_value = activeBenefMatricule
      }
      this.isLoading = false;
      this.isConsultationSuccess = false;
      let mat_form = {
        matricule: this.input_value,
      };
  
      this.itemBeneficiare = {};
      this.itemConsultation = {};
  
      let cmu_form = {
        numero_cnam: this.input_value,
      };
      if (!this.input_value) {
        const messages: { [key: string]: string } = {
          CMU: 'Veuillez reseigner numéro CMU',
          MAT: 'Veuillez reseigner numéro matricule',
        };
  
        const message = messages[this.input_option];
  
        if (message) {
          this.utilities.showSweetNotification(message, 'error');
          this.isLoading = false;
          return;
        }
      }
  
      let request = {
        // user_id:this.user.id,
        is_required_dossier: true,
        data: this.input_option == 'CMU' ? cmu_form : mat_form,
      };
  
      this.isLoading = true;
  
      this.restClient.post('beneficiaire/search', request).subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res && !res['hasError']) {
            this.itemBeneficiare = res.item;
            this.authService.setActiveBeneficiaire(res.item)
            this.onSendBenefItem.emit(this.itemBeneficiare)
            this.getItemsPrescriptionActive()
            this.dossierActif = res.item.dossier_actif
            this.prestationActive = res.item.prestation_active
  
          } else {
            this.utilities.showSweetNotification(
              res['status']['message'],
              'error'
            );
            this.itemBeneficiare = {};
          }
        },
        (error) => {
          this.isLoading = false;
          this.utilities.showSweetNotification(error, 'error');
          this.itemBeneficiare = {};
        }
      );
    }
    getItemsPrescriptionActive() {
      if(!this.itemsGarantie || !this.itemsGarantie.length)
        return
      let garantie_id = this.itemsGarantie.find((ig:any) => ig.codification == 'CONS')?.id ?? null;
      if(!garantie_id)
        return
      if(!this.itemBeneficiare.id)
        return
  
      this.selectedConsultation = {}
      let request = {
        index: 0,
        size: 1000,
        type_prescription: 'IMA',
        data: {
          garantie_id:garantie_id,
          matricule: this.itemBeneficiare.matricule,
          beneficiaire_id: this.itemBeneficiare.id,
          prestataire_id: this.user.prestataire_id,
          is_factured: 0
        },
      };
  
      this.restClient.post('prestationActe/getByCriteria', request).subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res && !res['hasError'] && res['items']) {
            this.itemsPrescription = res.items;
            console.log('this.itemsPrescription: ', this.itemsPrescription);
            this.itemsPrescription = this.itemsPrescription.filter((it: any) => it.count_ima_non_hospit == 0 && !it.is_expired && !it.is_factured );
            if (this.itemsPrescription && this.itemsPrescription.length) {
              this.itemsPrescription.map((ip: any) => {
                ip.is_active = false
              })
            }
  
          } else {
            this.utilities.showSweetNotification(
              res['status']['message'],
              'error'
            );
            this.itemsPrescription = [];
          }
        },
        (error) => {
          this.utilities.showSweetNotification(error, 'error');
          this.itemsPrescription = [];
        }
      );
    }
  
  
  
  
    uploadFile(event: any) {
      const reader = new FileReader();
      if (event.target.files && event.target.files.length) {
        const file = event.target.files[0];
        const fileName = file.name.split('.')[0];
        const Tabextension = file.name.split('.');
        const extension = Tabextension[Tabextension.length - 1];
  
        console.info('fileName', fileName);
        console.info('extension', extension);
        this.fileName1 = fileName + '.' + extension;
        reader.onload = (readerEvent) => {
          const data = (readerEvent.target as any).result;
          // this.imageDisplay = data;
          const fileBase64 = data.split(',')[1];
          this.currentFile = {
            fileBase64: fileBase64,
            fileName: fileName,
            extension: extension,
            typeDocument: 'custom type',
          };
        };
      }
  
      reader.readAsDataURL(event.target.files[0]);
    }
  
    onGetDossiers() { }
  
    generateUniqueString() {
      // Get current timestamp in milliseconds
      var timestamp = new Date().getTime();
  
      // Generate a random number
      var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed
  
      // Concatenate timestamp and random number
      var uniqueString = timestamp.toString() + randomNumber.toString();
  
      return uniqueString;
    }
  
  
    confirmSaveItem(data: any) {
      // item.specialiteId = this.selectedSpecialite.id
      if (!data || !data.renseignement_clinique) {
        this.utilities.showSweetNotification('Veuillez indiquer le renseignement clinique', 'error');
        return;
      }
  
  
  
      Swal.fire({
        title: "Prescription d'examen de radio",
        text: 'Souhaitez-vous poursuivre cette action?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0665aa',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
      }).then((result) => {
        if (result.value) {
          this.saveItems()
        }
      });
    }
  
    saveItems() {
      this.isConsultationSuccess = false;
  
      let file_data = '';
      if (this.currentFile && Object.keys(this.currentFile).length) {
        file_data = this.currentFile;
      }
  
      if (this.itemsElement && this.itemsElement.length) {
        this.itemsElement.map((im: any) => {
          im.affection_id = this.itemToSave.affection_id
          im.date_presription = this.itemToSave.date_presription
          im.mode_prescription = this.itemToSave.mode_prescription,
          im.matricule = this.itemBeneficiare.matricule,
          im.beneficiaire_id = this.itemBeneficiare.id,
          im.affection_id = this.itemToSave.affection_id
          im.prestation_acte_id = this.selectedConsultation.id
          im.dossier_id = this.selectedConsultation.dossier_id,
          im.garantie_id = this.itemsGarantie.find((itg: any) => itg.codification == 'IMA').id,
          im.renseignement_clinique=this.itemToSave.renseignement_clinique,
          im.prestataire_id = this.user.prestataire_id
        }
  
        )
      }
  
      if (this.currentFile && Object.keys(this.currentFile).length) {
        this.itemConsultation.file_data = this.currentFile;
      }
  
      let request = {
        file_data: this.currentFile && Object.keys(this.currentFile).length ? this.currentFile : '',
        datas: [...this.itemsElement],
      };
  
      this.restClient.post('prescriptionActex/create', request).subscribe(
        (res: any) => {
          // this.isLoading = false;
          if (res && !res['hasError']) {
            this.isConsultationSuccess = true;
            this.utilities.showSweetNotification(
              res['status']['message'],
              'succes'
            );
            this.itemsElement = []
            // this.goNext()
            this.getItemsPrescriptionActive()
          } else {
            this.isConsultationSuccess = false;
            this.utilities.showSweetNotification(
              res['status']['message'],
              'error'
            );
          }
          this.onClosePrescriptionMedocModal.emit('hide')
  
        },
        (error) => {
          this.isConsultationSuccess = false;
          this.utilities.showSweetNotification(error, 'error');
        }
      );
    }
  
    onAddItemToList(): void {
      if (!this.selectedItem || !this.selectedItem.id) {
        this.utilities.showSweetNotification(
          "Veuillez renseigner acte",
          'error'
        );
        return;
      }
      if (!this.itemToAdd || !this.itemToAdd.quantite) {
        this.utilities.showSweetNotification(
          "Veuillez renseigner quantité",
          'error'
        );
        return;
      }
  
  
      if(this.itemsElement && this.itemsElement.length){
        let isExist = this.itemsElement.filter((ie:any)=>ie.acte_id == this.selectedItem.id).length
        if(isExist){
           this.utilities.showSweetNotification(
              "Cet élément est dejà dans la liste",
              'error'
            );
            return
        }
       
      }
      console.log('obj: ', this.selectedItem)
  
  let obj = {
        is_entente_prealable: this.selectedItem.is_entente_prealable,
        is_exclu: this.selectedItem.is_exclu,
        acte_id: this.selectedItem.id,
        acte_libelle: this.selectedItem.libelle,
        quantite: this.itemToAdd.quantite,
        garantie_id:this.selectedItem.garantie_id,
        is_referred: this.selectedItem.is_referred
      }
      
      this.itemsElement.unshift({ ...obj })
      this.clearText = true
      this.reload = !this.reload
      // this.itemToAdd = { quantite: 1 }
      this.itemToAdd = {}
       this.itemToAdd.quantite = 1
      this.selectedItem = {}
  
      // Force value to change so ngOnChanges() is triggered
      this.cancelItemSelected = false;
      setTimeout(() => {
        this.cancelItemSelected = true;
      }, 0);
    }
  
    onSelectRow(item: any): void {
      // if (this.isExpired(item.date_expiration)) return;
      this.selectedConsultation = { ...item }
      if (item.is_expired) return;
  
      this.itemsPrescription.forEach((p: any) => p.is_active = false);
      item.is_active = true;
      console.log('Selected prescription: ', item);
    }
  
    isExpired(expirationDate: string | Date): boolean {
      if (!expirationDate) return false; // Handle cases with no expiration date
  
      const expDate = new Date(expirationDate);
      const today = new Date();
  
      // Compare dates (ignoring time)
      return expDate.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0);
    }
  
    ngOnChanges(changes: SimpleChanges) {
      console.log('changes: ', changes)
      if (changes['refreshTriggerOrdonnance'] && changes['refreshTriggerOrdonnance'].currentValue) {
        console.log('Triggered refreshTriggerOrdonnance')
        let activeBeneficiaire = this.authService.getActiveBeneficiaire()
        console.log('activeBeneficiaire.matricule in ngOnChanges ordonnance: ', activeBeneficiaire.matricule)
        if (activeBeneficiaire.matricule) {
          this.input_value = activeBeneficiaire.matricule
          this.searcheBenef(activeBeneficiaire.matricule)
        }
      }
  
  
    }
  
    onSelectMedoc(event: any) {
      console.log('current medoc', event)
      this.selectedItem = event || {}
    }
    onSelectMedocPro(event: any) {
      console.log('current medoc', event)
      this.selectedItem = event || {}
      // getTarifActe()
      this.itemToAdd.quantite=1
      // this.onAddItemToList()
    }
  
    goNext() {
      this.onGoToTab.emit('pharmacie')
    }
  
    removeItem(index: number): void {
      if (confirm('Êtes-vous sûr de vouloir supprimer cet élément?')) {
        this.itemsElement.splice(index, 1);
      }
    }
  
      // onSetUserInfo(event:any){
      // if(event.id){
      //   this.itemBeneficiare=event
      //   this.authService.setActiveBeneficiaire(event)
      //   this.getItemsPrescriptionActive()
      // }
  
        onSetUserInfo(event: any) {
      if (event.id) {
        this.itemBeneficiare = event
        this.authService.setActiveBeneficiaire(event)
        this.itemConsultation = {}
        this.beneficiaireAutOselect = this.itemBeneficiare
        this.getItemsPrescriptionActive()
      }
      else {
        this.authService.setActiveBeneficiaire({})
        this.beneficiaireAutOselect = {}
      }
  
    }
  
  
    getTarifActe(acte_id:any) {
      // this.itemConsultation={raison_consultation_id: this.itemConsultation.raison_consultation_id,medecin_id:this.itemConsultation.medecin_id}
      let request = {
        index: 0,
        size: 1000,
        data: {
          acte_id: acte_id,
          matricule: this.itemBeneficiare.matricule,
          prestataire_codification: this.user.prestataire_codification,
        },
      };
  
      // this.restClient.post('tarifActe/getActiveValues', request).subscribe(
      this.restClient.post('bareme/deepSeek', request).subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res && !res['hasError'] && res['item']) {
            // this.itemTarifActe = res.item;
            // delete this.itemTarifActe.consommation
            // delete this.itemTarifActe.plafond
            // this.itemConsultation = { raison_consultation_id: this.itemConsultation.raison_consultation_id, medecin_id: this.itemConsultation.medecin_id, acte_id: this.itemConsultation.acte_id }
            // this.itemConsultation = { ...this.itemTarifActe, ...this.itemConsultation }
            // delete this.itemConsultation.id
            // console.log('this.itemTarifActe: ', this.itemTarifActe);
          } else {
            this.utilities.showSweetNotification(
              res['status']['message'],
              'error'
            );
            // this.itemTarifActe = {};
            // this.itemConsultation.acte_id = ''
            // this.itemConsultation = { raison_consultation_id: this.itemConsultation.raison_consultation_id, medecin_id: this.itemConsultation.medecin_id }
  
          }
        },
        (error) => {
          this.utilities.showSweetNotification(error, 'error');
          this.itemConsultation = { raison_consultation_id: this.itemConsultation.raison_consultation_id, medecin_id: this.itemConsultation.medecin_id }
          // this.itemTarifActe = {};
        }
      );
    }
  
  
    getItemsGarantie() {
      let request = {
        index: 0,
        size: 1000,
        data: {},
      };
  
      this.restClient
        .post('garantie/getByCriteria', request)
        .subscribe(
          (res: any) => {
            this.isLoading = false;
            if (res && !res['hasError'] && res['items']) {
              this.itemsGarantie = res.items;
              console.log(
                'this.itemsGarantie: ',
                this.itemsGarantie
              );
              // this.getItemsActe()
               this.getItemsPrescriptionActive()
  
              this.itemConsultation.raison_consultation_id =
                this.itemsGarantie[0].id;
            } else {
              this.utilities.showSweetNotification(
                res['status']['message'],
                'error'
              );
              this.itemsGarantie = [];
            }
          },
          (error) => {
            this.utilities.showSweetNotification(error, 'error');
            this.itemsGarantie = [];
          }
        );
    }
  
}
